<template>
  <div class="role-group">
    <button
      type="button"
      class="role-group__head"
      :class="{ 'role-group__head--open': bottomcontentshow }"
      @click="handleClick"
    >
      <span class="role-group__icon" aria-hidden="true">
        <van-icon name="friends-o" />
      </span>
      <span class="role-group__body">
        <span class="role-group__title">{{ mianname }}</span>
        <span class="role-group__desc">{{ miannamedesc }}</span>
      </span>
      <van-icon
        v-if="list.length > 1"
        name="arrow"
        class="role-group__chevron"
        :class="{ 'role-group__chevron--open': bottomcontentshow }"
        aria-hidden="true"
      />
      <van-icon
        v-else
        name="arrow"
        class="role-group__chevron"
        aria-hidden="true"
      />
    </button>

    <div
      v-show="bottomcontentshow"
      class="role-group__panel"
    >
      <button
        v-for="(item, index) in list"
        :key="index"
        type="button"
        class="role-group__row"
        @click="handleInnerClick(item)"
      >
        <span class="role-group__row-text">{{ item.fullName }}</span>
        <van-icon name="arrow" class="role-group__row-arrow" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

const useItemEffect = (emit, list) => {
  const mianname = ref("");
  const miannamedesc = ref("");
  const arrowrotate = ref(false);
  const bottomcontentshow = ref(false);
  mianname.value = `${list[0].maintitle} ${
    list.length > 1 ? "X" + list.length : ""
  }`;
  miannamedesc.value = list[0].fullName;
  arrowrotate.value = list.length > 1;
  const handleClick = () => {
    console.log("handleClick");
    if (list.length > 1) {
      bottomcontentshow.value = !bottomcontentshow.value;
    } else {
      emit("handleItemClick", list[0]);
    }
  };
  const handleInnerClick = (item) => {
    console.log("handleInnerClick");
    emit("handleItemClick", item);
  };
  return {
    handleClick,
    handleInnerClick,
    mianname,
    miannamedesc,
    arrowrotate,
    bottomcontentshow,
  };
};

export default {
  name: "SelectDownItemRedesign",
  emits: ["handleItemClick"],
  props: {
    roleItem: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const list = props.roleItem;
    const {
      handleClick,
      handleInnerClick,
      mianname,
      miannamedesc,
      arrowrotate,
      bottomcontentshow,
    } = useItemEffect(emit, list);
    return {
      handleClick,
      handleInnerClick,
      mianname,
      miannamedesc,
      arrowrotate,
      bottomcontentshow,
      list,
    };
  },
};
</script>

<style lang="scss" scoped>
$green: #009343;
$green-light: #e8f5ed;
$surface: #ffffff;
$ink: #1a1f1c;
$label: #8a9490;
$border: #e8edea;
$card-radius: 0.12rem;
$ease-out: cubic-bezier(0.22, 1, 0.36, 1);

.role-group {
  background: $surface;
  border: 0.01rem solid $border;
  border-radius: $card-radius;
  overflow: hidden;
  box-shadow: 0 0.02rem 0.08rem rgba(13, 40, 24, 0.04);
  text-align: left;
}

.role-group__head {
  display: flex;
  align-items: center;
  gap: 0.12rem;
  width: 100%;
  padding: 0.14rem 0.14rem;
  border: none;
  background: $surface;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s $ease-out;

  &:active {
    background: $green-light;
  }

  &--open {
    border-bottom: none;
  }
}

.role-group__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.36rem;
  height: 0.36rem;
  border-radius: 50%;
  background: $green-light;
  color: $green;
  font-size: 0.18rem;
}

.role-group__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
}

.role-group__title {
  font-size: 0.14rem;
  font-weight: 600;
  color: $ink;
  line-height: 1.35;
}

.role-group__desc {
  font-size: 0.12rem;
  color: $label;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.role-group__chevron {
  flex-shrink: 0;
  color: $green;
  font-size: 0.14rem;
  transition: transform 0.2s $ease-out;

  &--open {
    transform: rotate(90deg);
  }
}

.role-group__panel {
  max-height: 2.4rem;
  overflow-y: auto;
  background: $surface;
  border-top: 0.01rem solid $border;
}

.role-group__row {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  width: 100%;
  min-height: 0.48rem;
  padding: 0.12rem 0.14rem;
  border: none;
  border-top: 0.01rem solid $border;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s $ease-out;

  &:first-child {
    border-top: none;
  }

  &:active {
    background: $green-light;
  }
}

.role-group__row-text {
  flex: 1;
  min-width: 0;
  font-size: 0.13rem;
  color: $ink;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.role-group__row-arrow {
  flex-shrink: 0;
  color: $green;
  font-size: 0.14rem;
}

@media (prefers-reduced-motion: reduce) {
  .role-group__head,
  .role-group__chevron,
  .role-group__row {
    transition: none;
  }
}
</style>
